import { useToasts } from 'app/components/Toast';
import { Dialog, DialogProps } from 'primereact/dialog';
import React, { useMemo } from 'react';
import { useAppConfig } from '../../hooks/useAppConfig';
import { useUpdateTaskMutation } from '../../services';
import { IDailyTask, ITask } from '../../types';
import FormTask, { TTaskForm } from '../forms/FormTask';

const ModalEditTask = (props: DialogProps & { dailyTask: IDailyTask, task: ITask }) => {
    const { getConfigByName } = useAppConfig();
    const [updateTask, { isLoading }] = useUpdateTaskMutation();
    const toast = useToasts();

    const onSubmit = async (values: TTaskForm) => {
        const { id, dailyTaskId, desc, inputField, ...data } = values;
        try {
            await updateTask({
                id,
                dailyTaskId,
                inputField: inputField ?? null,
                desc,
                ...data
            })
            props.onHide();
        } catch (error) {
            toast.toastError('Update task failed.', error?.data?.message);
        }

    };

    const options = useMemo(() => {
        const config = getConfigByName('taskInputField');
        if (!config) return [];

        return config.map((val) => {
            return Object.entries(val).reduce((a, [value, label]) => {
                return { value, label }
            }, {})
        });
    }, [getConfigByName]);

    return (
        <Dialog header="Edit Task" modal style={{ width: '20vw' }} {...props}>
            <FormTask
                dailyTaskId={props.dailyTask.id}
                onSubmit={onSubmit}
                inputFieldOptions={options}
                isLoading={isLoading}
                task={props.task}
                onCancel={props.onHide}
            />
        </Dialog>
    );
};

export default ModalEditTask;
